import * as H from "history";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../../store";
import {AsyncJsonViewer} from "../../../AsyncJsonViewerCard";
import ApiService from "../../../ApiService";

interface IndustryDataPageProps {
    tenantId: string;
    apiService: ApiService;
}

interface IndustryDataPageState {
    flowSetsPromise: Promise<any[]>
    flows: outboundFlow[] | undefined;
}

interface outboundFlow {
    id: string;
    promise: Promise<any[]>
}

class IndustryDataPage extends Component<IndustryDataPageProps, IndustryDataPageState> {

    constructor(props: IndustryDataPageProps) {
        super(props);

        this.state = {
            flowSetsPromise: this.props.apiService.getOutboundProvisionFlowSets(this.props.tenantId),
            flows: undefined
        };
    }

    async componentDidMount(): Promise<void> {
        let outboundFlows: outboundFlow[] = [];

        let flowSets = await this.state.flowSetsPromise;

        flowSets.forEach(async flowSet => {

            let flow = this.props.apiService.getProvisionFlows(this.props.tenantId, flowSet.id)

            outboundFlows.push({ id: flowSet.id, promise: flow });
        })
        this.setState({ flows: outboundFlows })
    }

    render() {

        const industryDataRunsPromise = this.props.apiService.getIndustryDataRuns(this.props.tenantId);

        return (
            <Fragment>
                <AsyncJsonViewer title={"Inbound File Flows"} getData={() => this.props.apiService.getInboundFileFlows(this.props.tenantId)}/>
                <AsyncJsonViewer title={"Source System Definitions"} getData={() => this.props.apiService.getSourceSystemDefinitions(this.props.tenantId)}/>
                <AsyncJsonViewer title={"Industry Data Connectors"} getData={() => this.props.apiService.getIndustryDataConnectors(this.props.tenantId)}/>
                <AsyncJsonViewer title={"Industry Data Runs"} getData={() => industryDataRunsPromise}/>
                <AsyncJsonViewer title={"Industry Data Run Statistics"} getData={() => {
                    return industryDataRunsPromise.then(runs => {
                        if(runs.length > 0)
                        {
                            return this.props.apiService.getIndustryDataRunStatistics(this.props.tenantId,runs[0].id)
                        }
                        return null;
                    });
                }}/>
                <AsyncJsonViewer title={"File Validate Operations"} getData={() => this.props.apiService.getFileValidateOperations(this.props.tenantId)} />
                <AsyncJsonViewer title={"Outbound Provisioning Flow Sets"} getData={() => this.state.flowSetsPromise} />
                {
                    this.state.flows?.map(x => {
                        return <AsyncJsonViewer title={`Outbound Flows for set: ${x.id}`} getData={() => x.promise} />
                    })
                }
                <AsyncJsonViewer title={"SDS Years"} getData={() => this.props.apiService.getSdsYearReferenceDefinitions(this.props.tenantId)} />

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { history: H.History, match: any }): IndustryDataPageProps => {
        return {
            apiService: state.auth.apiService,
            tenantId: ownProps.match.params.tenantId
        };
    }
)(IndustryDataPage);